import { h, Component } from 'preact';
import cx from 'classnames';
import dlv from 'dlv';

import style from './style.less';

import CardHeader from '../../pieces/card-header';

import { trackingProvider, DIMENSION, trackProps } from '@cube/track';

@trackingProvider({
	[DIMENSION.componentpath]: 'SupportClusterP23'
})
export default class SupportClusterP23 extends Component {

	render({ title, titleLink, links, shuffle, layout, clusterClass, qeId, ...props }) {
		if (!links) return null;

		return (
			<div class={cx(style.supportClusterP23, clusterClass)} id={qeId} qid={qeId}>
				<CardHeader title={title} qeId={qeId} link={titleLink} />
				<div class={style.cards}>
					{ links.map((item, i) => (
						<div class={style.card} qid={qeId + '-item-' + i}>
							<a href={dlv(item, 'link.href')} target={dlv(item, 'link.open_new_window') ? '_blank' : '_self'}
								rel="noopener noreferrer"
								{...trackProps({
									[DIMENSION.contenttitle]: item.title,
									[DIMENSION.clickindex]: i+1
								}, this.context)}
							>
								<img src={item.image} />
								<div class={style.title}>{item.title}</div>
								<div class={style.summary}>{item.summary}</div>
							</a>
						</div>
					)) }
				</div>
			</div>
		);
	}
}
